
import { apiLogisticsConfigDetail, apiLogisticsConfigSet } from "@/api/setting";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class Logistics extends Vue {
  form = {
    express_bird: {
      set_meal: "free",
      app_key: "",
      ebussiness_id: "",
    },
    express_hundred: {
      interface_type: "enterprise",
      app_key: "",
      customer: "",
    },
    track: {
      app_key: "",
    },
    express_type: "express_bird",
  };
  handleSave() {
    apiLogisticsConfigSet(this.form).then((res: any) => {
      if (res.code == 200) {
        this.$message({
          message: "保存成功",
          type: "success",
        });
      }
    });
  }
  getLogisticsConfig() {
    apiLogisticsConfigDetail({}).then((res: any) => {
      this.form = res;
    });
  }
  created() {
    this.getLogisticsConfig();
  }
}
